// Brand typefaces — Lora (serif body) + Raleway (sans headings).
import "typeface-lora"
import "typeface-raleway"

// normalize CSS across browsers
import "./src/css/normalize.css"

// custom CSS styles (brand tokens + base)
import "./src/css/style.css"

import { trackPageView } from "./src/utils/analytics"

// GA4 (gtag.js) is loaded ONCE by gatsby-ssr.js into the static <head>; that inline snippet
// runs before hydration, so window.gtag + dataLayer and the initial config already exist by the
// time the client boots. onClientEntry used to append a SECOND gtag script and re-run config
// here — removed, so the library loads once. onRouteUpdate sends SPA page_views (config sets
// send_page_view:false); the send itself lives in src/utils/analytics.js, which owns every
// window.gtag call and defers the event until the new <title> has committed.

export const onRouteUpdate = ({ location }) => trackPageView(location)

// Wrap every page in the funeral-ui provider (shared with gatsby-ssr.js).
export { wrapRootElement } from "./src/wrapRootElement"
